module.exports = __webpack_public_path__ + "static/Pt07-201e0258862c81040cae1f8bcf701f89.jpg";